import { createFileRoute } from "@tanstack/react-router"
import { z } from "zod"
import { ImageGeneratorPageWrapper } from "./-ImagePage"

const imageGeneratorSearchSchema = z.object({
  model: z.string().optional(),
  prompt: z.string().optional(),
  aspect_ratio: z.string().optional(),
  negative_prompt: z.string().optional(),
})

export const Route = createFileRoute("/create/image")({
  validateSearch: imageGeneratorSearchSchema,
  component: ImageGeneratorPageWrapper,
})
